/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page2_Warning_ContactInputs */



/**
* | output |
* | --- |
* | "During the intervention, contact EISOX support for optimal assistance." |
*
* @param {Intervention_Plan_Pdf_Page2_Warning_ContactInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page2_warning_contact = /** @type {((inputs?: Intervention_Plan_Pdf_Page2_Warning_ContactInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page2_Warning_ContactInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("During the intervention, contact EISOX support for optimal assistance.")
	return /** @type {LocalizedString} */ ("Pendant l'intervention, contactez le support EISOX pour un accompagnement optimal.")
});